import React from "react";
import { notification } from "antd";

const Opennotification = (type, message, description)=>{
    
    notification[type]({
        message,
        description,
        placement: "topRight",
        });
    
    return(
        <>
        
        </>
    )

}

export default Opennotification;